import React, { Component } from 'react';
import {connect} from "react-redux";
import Statistics from "../../components/Statistics/Statistics";
import * as actions from "../../actions";

class StatisticsHOC extends Component{
    handleFilterChange = ({from, to, filterCategory, filterValue}) => {
        // Filtered statistics are computed server-side so they reflect the whole
        // database for the selected range, not just the chats loaded in the UI.
        this.props.fetchFilteredChatStatistics({
            token: this.props.token,
            from,
            to,
            filterCategory,
            filterValue
        });
    };

    render() {
        return (
            <Statistics
                {...this.props}
                onFilterChange={this.handleFilterChange}
                loginsCharts={{title: 'Logins',
                    data: [this.props.stats.returningChats || 0, this.props.stats.newChats || 0],
                    dataLabels: ['Returning','New']}}
                agesCharts={{title: 'Ages',
                    dataLabels :['11-', '12', '13', '14', '15', '16', '17', '18+'],
                    datasetLabel:'Age',
                    bgColor:'#6197e9',
                    borderColor:'#6164ff'}}
            />

        );
    }
}

const mapStateToProps = state => {
    return {
        stats: state.statistics.stats,
        loadingStats: state.statistics.loading,
        filteredStats: state.statistics.filteredStats,
        loadingFilteredStats: state.statistics.loadingFilteredStats,
        token: state.user.token,
        childUsers: state.childUsers.byId,
        feelingsCodes: state.general.feelings
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchFilteredChatStatistics: (payload) => dispatch(actions.fetchFilteredChatStatistics(payload))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsHOC);
